import React, { useState } from 'react';
import '../blocks/ModernBlocks.css';

const FAQBlock = ({ data }) => {
  const [openQuestions, setOpenQuestions] = useState([]);

  const toggleQuestion = (index) => {
    setOpenQuestions(prev => 
      prev.includes(index) 
        ? prev.filter(i => i !== index)
        : [...prev, index]
    );
  };

  return (
    <section className="faq-section">
      <div className="faq-container">
        <div className="faq-header">
          <h2 className="faq-title">{data.title}</h2>
          <p className="faq-subtitle">{data.subtitle}</p>
        </div>
        <div className="faq-list">
          {data.items.map((item, index) => (
            <div key={index} className="faq-item">
              <button 
                className={`faq-question ${openQuestions.includes(index) ? 'active' : ''}`}
                onClick={() => toggleQuestion(index)}
              >
                <span>{item.question}</span>
                <svg 
                  className={`faq-icon ${openQuestions.includes(index) ? 'rotated' : ''}`}
                  width="20" 
                  height="20" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2"
                >
                  <path d="M19 9l-7 7-7-7"/>
                </svg>
              </button>
              <div className={`faq-answer ${openQuestions.includes(index) ? 'open' : ''}`}>
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQBlock; 